var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"d-block",attrs:{"value":_vm.selected,"placeholder":_vm.plc || _vm.$t('message.user'),"filterable":"","clearable":"","size":_vm.size,"multiple":_vm.multiple,"own_id":_vm.own_id},on:{"input":_vm.dispatch}},_vm._l((_vm.filtered),function(user){return _c('el-option',{key:user.id,attrs:{"label":(user.surname ? user.surname : '') +
      ' ' +
      (user.name ? user.name : '') +
      ' ' +
      (user.patronymic ? user.patronymic : ''),"value":user.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }